import './App.css';
import Home from './component/Home';
import TutorialBox from './component/TutorialBox';
import AuthorBox from './component/AuthorBox';
import LatestBox from './component/LatestBox.jsx';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Url } from './constant/global.js';
import { useNavigate } from 'react-router-dom';

export default function App() {

    const [banner, setBanner] = useState([]);
    const [tutorial, setTutorial] = useState([]);
    const [author, setAuthor] = useState([]);
    const navigate=useNavigate()

    const fetchBannerData = () => {
        try{
            axios.get(Url+'/tutorials/aBkxYl1h0q/banners/')
            .then((response) => {
                return response.data;
            })
            .then((data) => {
                let mybanner = data;
                setBanner(mybanner);
            })
        }
        catch(e){

        }
    }

    const fetchTutorialData = () => {
        try{
            axios.get(Url+'/tutorials/aBkxYl1h0q/tutorial-types/')
            .then((response) => {
                return response.data;
            })
            .then((data) => {
                let mytutorial = data;
                setTutorial(mytutorial);
            })
        }
        catch(e){
            
        }
        
    }

    const fetchAuthorData = () => {
        try{
            axios.get(Url+'/tutorials/aBkxYl1h0q/author-views/')
            .then((response) => {
                return response.data;
            })
            .then((data) => {
                let myauthor = data;
                setAuthor(myauthor);
            })
        }
        catch(e){
            
        }
        
    }

    useEffect(() => {
        fetchBannerData();
        fetchTutorialData();
        fetchAuthorData();
    }, [])



    return (
        <>
            <div className='row'>
                <div className='col-md-7 col-xs-12 col-lg-7 col-xl-7 my-2'>
                    <Home bannerList={banner} />
                    <TutorialBox tutorialList={tutorial} />
                    <AuthorBox authorList={author} />
                </div>
                <div className='col-md-4 col-xs-12 col-lg-4 col-xl-4'>
                    {/* <TableBox tables={tables} /> */}
                    <h4 className="latest-box mt-3 h4">Recent Developments</h4>
                    <h4 className="latest-box-table mt-3 h4" style={{cursor:'pointer',color:'#b84736'}} onClick={()=>navigate("tableDetails")}  >Learn Multiplication Tables</h4>

                    <LatestBox />
                </div>

            </div>


        </>
    )
}

